module.exports = __webpack_public_path__ + "70953e6244aae506fefbb94e92610be4.png";